import { Box, Typography, Container, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { Helmet } from "react-helmet-async";
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import SecurityIcon from '@mui/icons-material/Security';
function AboutUs() {

    return (
        <div>
            <Helmet>
                <title>About Us - capsuleme.io</title>
                <meta name='description' content='Learn more about us.' />
            </Helmet>
            <Box display="flex"
                flexDirection={"column"}
                width="75vw" // Set width to 50% of the viewport width
                alignItems={'center'}
                justifyContent={'center'}
                margin={'auto'}
                marginTop={12}
                padding={3}
                borderRadius={5}
            >
                <Container>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
                        <Typography variant="h2" sx={{ fontWeight: 'bold' }}>About</Typography><Typography variant="h2" sx={{ color: '#2574eb' }}>Capsuleme</Typography>

                    </Box>
                    <Typography sx={{ textAlign: 'center', width: '100%', maxWidth: '600px', margin: '0 auto' }} gutterBottom>
                        Your private, secure, and intuitive space to capture your thoughts, reflect on your days, and chronicle your life's journey.
                    </Typography>

                    <Typography variant="h5" sx={{ textAlign: 'left' }} gutterBottom>Our Mission</Typography>
                    <Typography sx={{ textAlign: 'left' }} gutterBottom>In a fast-paced world, taking a moment for introspection is more important
                        than ever. Our mission is to provide a simple yet powerful tool that makes
                        journaling an accessible and rewarding habit for everyone. We believe that
                        by providing a seamless platform for self-expression, we can help you unlock
                        personal insights, foster mindfulness, and create a valuable record of your
                        personal growth.</Typography>

                    <Typography variant="h5" sx={{ textAlign: 'left', marginTop: "2vw" }} gutterBottom>Why Journal with Us?</Typography>
                    <Typography sx={{ textAlign: 'left' }} gutterBottom>Capsuleme was born from a desire to combine the timeless practice of
                        journaling with the convenience of modern technology. We focus on three core
                        principles:</Typography>

                    <List sx={{ textAlign: 'left' }}>
                        <ListItem key="simplicity">
                            <ListItemIcon>
                                <LightbulbIcon sx={{ color: '#2574eb' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary="Simplicity"
                                secondary="  clean, distraction-free interface that puts your thoughts front and
                                                center. No clutter, just a pure writing experience."
                            />
                        </ListItem>
                        <ListItem key="security">
                            <ListItemIcon>
                                <SecurityIcon sx={{ color: '#2574eb' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary="Security"
                                secondary="Your
                                                privacy is our utmost priority. Your entries are encrypted and securely
                                                stored, ensuring your personal reflections remain truly personal."
                            />
                        </ListItem>
                        <ListItem key="growth">
                            <ListItemIcon>
                                <ThumbsUpDownIcon sx={{ color: '#2574eb' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary="Personal Growth"
                                secondary="Reflect on your journey and track your personal development over time."
                            />
                        </ListItem>
                    </List>

                    <Typography variant="h5" sx={{ textAlign: 'left', marginTop: "2vw" }} gutterBottom>Our Vision</Typography>
                    <Typography sx={{ textAlign: 'left' }} gutterBottom>We envision a world where everyone has the tools to better understand
                        themselves. We are continuously working to enhance Capsuleme with
                        features that inspire creativity, encourage consistency, and deepen the
                        connection you have with your inner self. Join us on this journey to make
                        self-reflection a cornerstone of daily life.</Typography>
                </Container>
                {/* <Container sx={{ mt: 4 }}> <Typography variant="h3" gutterBottom>We are excited to welcome to Héritage. We are building a platform for you to write your journal.</Typography></Container>
            <Container sx={{ mt: 4 }}> <Typography variant="h3" gutterBottom>Please request for early access if you are interested to be part of this amazing journey.</Typography></Container> */}
            </Box>
        </div>)
}

export default AboutUs;

